import axios from 'axios';

export const api = axios.create({ baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5000/api', timeout: 8000 });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('asian_axxon_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export async function submitAppointment(payload) {
  const { data } = await api.post('/appointments', payload);
  return data.data;
}
